import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Center } from '@mantine/core'
import { useUser } from '@/contexts/UserContext'
import Loading from './Loading'

const QuickStart: React.FC = () => {
  const navigate = useNavigate()
  const { connection } = useUser()

  // TODO: Fix this: if connected but redirected to this page it halts the app
  useEffect(() => {
    if (connection !== 'connected') {
      navigate('/connect')
    }
  }, [connection])

  return (
    <Center>
      <Loading />
    </Center>
  )
}

export default QuickStart
